/* ★ POPUP "TIADA RUANG GAMBAR" — larian Agent Saya (tab My Agent) DITAHAN (keputusan user 2026-09-13).
 *
 * Muncul bila agent yang dipilih menyimpan gambar ke kad, tetapi satu atau lebih kad yang
 * ditanda sudah penuh (4 gambar tambahan). Aturan user: TIADA automation dijalankan langsung
 * sehingga pelanggan membetulkannya atau memilih kad lain. Kad terlibat turut ditanda kuning
 * dalam senarai (WorkspaceView) — popup ini hanya menerangkan sebab + cara betulkan.
 *
 * TEKS SAHAJA. Rupa dikongsi dengan popup Run Flow melalui PopupRunDitahan (2026-09-18) —
 * markup kekal sama seperti versi asal fail ini. Semakan ruang dibuat oleh `kadTiadaRuangGambar`
 * (utils/agentGambar.js). Dikongsi dua rupa: teks lalu `T(kunci, lalai, vars)` pemanggil
 * (rupa lama = ayat lalai).
 */
import React from 'react';
import { MAKS_GAMBAR_TAMBAHAN } from '../utils/agentGambar';
import PopupRunDitahan from './PopupRunDitahan';

export default function PopupRuangGambarAgent({ senarai, onTutup, T }) {
    if (!Array.isArray(senarai) || senarai.length === 0) return null;

    const n = senarai.length;
    const maks = MAKS_GAMBAR_TAMBAHAN;
    const jumlah = maks + 1;

    return (
        <PopupRunDitahan
            ikon="hide_image"
            idTajuk="prg-tajuk"
            tajuk={n === 1
                ? T('ws.agent.ruang.tajuk1', '1 card tiada ruang gambar')
                : T('ws.agent.ruang.tajuk', `${n} card tiada ruang gambar`, { n })}
            sebab={T('ws.agent.ruang.sebab', `Agent ini menyimpan gambar ke card. Satu card boleh menyimpan ${jumlah} gambar sahaja: 1 gambar utama dan ${maks} gambar tambahan. Card di bawah sudah tiada ruang untuk gambar baharu.`, { jumlah, maks })}
            senarai={senarai.map((k) => ({
                id: k.id,
                nama: k.nama,
                keterangan: T('ws.agent.ruang.baris', `Gambar tambahan ${k.ada}/${maks} · perlu ${k.perlu} ruang kosong`, { ada: k.ada, maks, perlu: k.perlu }),
            }))}
            caraTajuk={T('ws.agent.ruang.caraTajuk', 'Cara betulkan')}
            cara={[
                T('ws.agent.ruang.cara1', 'Tekan Edit data pada card yang ditanda, buang gambar tambahan yang tidak diperlukan, kemudian Simpan.'),
                T('ws.agent.ruang.cara2', 'Atau buang tick pada card itu dan pilih card lain.'),
                T('ws.agent.ruang.cara3', 'Tekan Run semula.'),
            ]}
            nota={T('ws.agent.ruang.tiadaJalan', 'Tiada automation dijalankan.')}
            butang={T('ws.agent.ruang.faham', 'Faham')}
            onTutup={onTutup}
            T={T}
        />
    );
}
